// extracted by mini-css-extract-plugin
export default {"marketingOption":"MarketingCheckbox_marketingOption__Hc9+9","marketingOptionDE":"MarketingCheckbox_marketingOptionDE__C9Be2"};